/**
 * スクロールアニメーション
 * IntersectionObserverを使用して、要素が画面内に入ったときにアニメーションを発火
 */

const DEFAULT_ROOT_MARGIN = '0px 0px -100px 0px';

/**
 * スクロールアニメーションを初期化
 * @param {string} [selector='[data-scroll-animation]'] - 対象要素のセレクタ
 * @param {string} [rootMargin] - rootMargin（指定しない場合はdata-scroll-marginまたはデフォルト値）
 */
const initScrollAnimation = (
  selector = '[data-scroll-animation]',
  rootMargin,
) => {
  const targets = document.querySelectorAll(selector);

  if (targets.length === 0) {
    return;
  }

  // rootMarginが指定されている場合は全要素に適用
  if (rootMargin) {
    let activeCount = 0;
    const total = targets.length;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-animated', 'true');
            observer.unobserve(entry.target);
            activeCount++;
          }
        });

        if (activeCount === total) {
          observer.disconnect();
        }
      },
      { rootMargin, threshold: 0 },
    );

    targets.forEach((target) => observer.observe(target));
    return;
  }

  // rootMarginが指定されていない場合は要素ごとのdata-scroll-marginを使用
  const groups = new Map();

  targets.forEach((target) => {
    const margin = target.dataset.scrollMargin || DEFAULT_ROOT_MARGIN;
    if (!groups.has(margin)) {
      groups.set(margin, []);
    }
    groups.get(margin).push(target);
  });

  groups.forEach((elements, margin) => {
    let activeCount = 0;
    const total = elements.length;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-animated', 'true');
            observer.unobserve(entry.target);
            activeCount++;
          }
        });

        if (activeCount === total) {
          observer.disconnect();
        }
      },
      { rootMargin: margin, threshold: 0 },
    );

    elements.forEach((el) => observer.observe(el));
  });
};

/**
 * デフォルトのスクロールアニメーション
 */
const scrollAnimation = () => {
  initScrollAnimation();
};

export { scrollAnimation, initScrollAnimation };
